import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { mapRecTypeToBaseType } from '../models/ContentType';
import { IViewRecommendationInfo } from '../models/IViewRecommendationInfo';
import { Module } from '../Module';
import { GetRecommendedViewsRequest } from '../ServerApi/requests/GetRecommendedViewsRequest';
import { HideRecommendationRequest } from '../ServerApi/requests/HideRecommendationRequest';
import { UndoHideRecommendationRequest } from '../ServerApi/requests/UndoHideRecommendationRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { ResourceQuery } from './ResourceQuery';

export class ViewRecommendations {
  public static $inject = ['ServerService', 'FetcherFactory'];

  private getRecommendedViews: IListFetcher<IViewRecommendationInfo>;

  constructor(private server: ServerService, FetcherFactory: FetcherFactory) {
    this.getRecommendedViews = FetcherFactory.getServerResourceFetcher(GetRecommendedViewsRequest, ServerApiMapper.vizRecommendations);
  }

  public viewRecommendations(): ResourceQuery<IViewRecommendationInfo> {
    return new ResourceQuery(this.getRecommendedViews);
  }

  public hideRecommendation(objectType: string, objectId: string): ng.IPromise<IResult> {
    return this.server.sendRequest(new HideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }

  public undoHideRecommendation(objectType: string, objectId: string): ng.IPromise<IResult> {
    return this.server.sendRequest(new UndoHideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }
}

Module.instance().service('ViewRecommendations', ViewRecommendations);
